import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  LocalizeParser,
  LocalizeRouterService,
  LocalizeRouterSettings,
} from '@gilsdav/ngx-translate-router';

/**
 * Custom localize router service will have an additional method for changing the language without triggering navigation.
 * This is to get rid of the "broken" navigation since it contains language prefix that is not supported on this project.
 */
@Injectable({
  providedIn: 'root',
})
export class CustomLocalizeRouterService extends LocalizeRouterService {
  constructor() {
    const parser = inject<LocalizeParser>(LocalizeParser);
    const settings = inject<LocalizeRouterSettings>(LocalizeRouterSettings);
    const router = inject<Router>(Router);
    const route = inject<ActivatedRoute>(ActivatedRoute);

    super(parser, settings, router, route);
  }

  changeLanguageWithoutNavigation(lang: string): void {
    this.parser
      .translateRoutes(lang)
      .subscribe(() => this['applyConfigToRouter'](this.parser.routes));
  }
}
